import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type NotificationType = "success" | "info" | "warning" | "error";

export interface NotificationState {
    open?: boolean;
    type?: NotificationType;
    message?: string;
    timeout?: number | null;
    /** Serializable key for a callback in lib/notificationActions. */
    actionId?: string;
    actionLabel?: string;
}


export const notificationInitialState: NotificationState = {
    open: false,
    type: "info",
    message: "",
    timeout: 6000
};

export const NotificationSlice = createSlice({
    name: "notification",
    initialState: notificationInitialState,
    reducers: {
        addNotification: (_state, action: PayloadAction<NotificationState>) => ({
            ...notificationInitialState,
            ...action.payload,
            open: true
        }),
        clearNotification: (state) => ({ ...state, open: false })
    }
});

export const notificationActions = NotificationSlice.actions;
export const notificationReducer = NotificationSlice.reducer;